import { render } from "./CoreFeatures.vue?vue&type=template&id=2420c99c"
import script from "./CoreFeatures.vue?vue&type=script&lang=js"
export * from "./CoreFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__